import { consents as base } from './base';
import { consents as AT } from './AT';

export const featureConfigMap = {
    base,
    AT,
};
